import React from 'react';
import './newzealand.css'; // Import the CSS for styling

const NewZealand = () => {
  return (
    <div className="newzealand-page">
      <header className="newzealand-header">
        <h1>Study in New Zealand</h1> {/* Header for the page */}
      </header>
      <main className="newzealand-content">
        <section className="newzealand-section">
          <h2>Unique Education System</h2>
          <p>
            New Zealand’s education system emphasizes practical, hands-on learning and 
            critical thinking. Universities like the University of Auckland and the 
            University of Otago are known for their innovative approaches to education 
            and commitment to student success.
          </p>
        </section>
        <section className="newzealand-section">
          <h2>Natural Beauty</h2>
          <p>
            New Zealand’s breathtaking landscapes offer an incredible backdrop for your 
            studies. Students can enjoy outdoor adventures and recreational activities 
            while pursuing their education.
          </p>
        </section>
        <section className="newzealand-section">
          <h2>Warm and Welcoming Community</h2>
          <p>
            New Zealanders, known for their friendliness and hospitality, create a 
            welcoming and supportive environment for international students. The country’s 
            relaxed lifestyle and emphasis on work-life balance make it an ideal place for 
            study and personal growth.
          </p>
        </section>
      </main>
      <footer className="newzealand-footer">
        <p>Experience the unique blend of education and adventure in New Zealand!</p>
      </footer>
    </div>
  );
};

export default NewZealand;
